import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { VrCommonModule } from '../../vr-common.module';

import { VrcRadioGroupComponent } from './vrc-radio-group/vrc-radio-group.component';
import { VrcRadioButtonComponent } from './vrc-radio-button/vrc-radio-button.component';

const exports = [VrcRadioGroupComponent, VrcRadioButtonComponent];

@NgModule({
  declarations: [...exports],
  exports,
  imports: [
    CommonModule,
    VrCommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class VrcRadioModule { }
